/**
 * 页面 ↔ Service Worker 的消息契约。
 *
 * 这个文件被两端同时 import，所以不存在"一边改了另一边没改"。以前这类常量在 SW 里是
 * 硬编码的字符串，改一处漏一处，且失败完全静默（消息发出去没人接，什么都不会发生）。
 */
export const SW_MSG = {
    /** 页面 → SW：立刻接管（用户点了"立即更新"） */
    SKIP_WAITING: 'pwaship:skip-waiting',
    /** 页面 → SW：问版本 */
    GET_VERSION: 'pwaship:get-version',
    /** SW → 页面：版本应答 */
    VERSION: 'pwaship:version',
    /** SW → 页面：点了通知，去这个路径（已有窗口时用它，不用 client.navigate） */
    NAVIGATE: 'pwaship:navigate',
    /** SW → 页面：推送到达（页面在前台时可以据此刷新未读，而不必等下一次轮询） */
    PUSH: 'pwaship:push',
};
export function isSwMessage(data) {
    return typeof data === 'object' && data !== null && typeof data.type === 'string' && data.type.startsWith('pwaship:');
}
//# sourceMappingURL=messages.js.map